// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__QRmpJ","checked":"checkbox_checked__lQjmL","label":"checkbox_label__UmB+m"};